
import React from "react"
import { useTranslation } from "react-i18next"
import {
  Config,
  adjectives,
  animals,
  colors,
  uniqueNamesGenerator
} from "@joaomoreno/unique-names-generator"
import pkg from "../../../../../../package.json"

 
import {CASDOOR_CONFIG} from "../../utils/utils"
import { setErrorAlertMessage } from "../../../stores/NetworkStore"
import { useAppDispatch, useAppSelector } from "../../../hooks"

const clientId = CASDOOR_CONFIG.clientId;

const customConfig: Config = {
  dictionaries: [adjectives, animals, colors],
  separator: " ",
  length: 2
}

export default function GiteeLoginButton() {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [enabled, setEnabled] = React.useState<boolean>(false)
  const [isLowClientVersion, setLowClientVersion] = React.useState<boolean>(true)
  const [serverVersion, setServerVersion] = React.useState<string>("")
 


  React.useEffect(() => { 
    let serverVersionStore = localStorage.getItem("serverVersion") || "0.0.0";
    setServerVersion(serverVersionStore);
    let serverVersion = serverVersionStore.split(".");  
    let localVersion = pkg.version.split(".");   
    let sv = parseInt(serverVersion[0])*10000 + parseInt(serverVersion[1])*100;
    let lv = parseInt(localVersion[0])*10000 + parseInt(localVersion[1])*100;
    console.log("sv, lv", sv, lv) 
    setEnabled(true);
    if(lv < sv){ 
      setLowClientVersion(true);
    }else{
      setLowClientVersion(false);
    }
  }, [])


  async function signIn() {

    // 如果版本过低，就提示更新
    if (isLowClientVersion) {
      dispatch(setErrorAlertMessage(`当前服务器版本[${serverVersion}]，客户端版本[${pkg.version}]过低，请下载最新版本客户端，下载方法见公众号“爱游戏的星河”或者qq群:638177718`));
      // alert("服务器版本过低，请联系管理员更新服务器");
      return;
    }

    var protocol = window.location.protocol; // 获取协议部分，例如 "https:"
    var hostname = window.location.hostname; // 获取主机名部分，例如 "kimi.moonshot.cn"
    var port = window.location.port ? ':' + window.location.port : ''; // 获取端口部分，如果存在的话 
    var baseUrl = protocol + '//' + hostname + port;
    // console.log(baseUrl);

    let client_id = clientId;
    let redirect_uri = baseUrl+"";
    // https://cas.52kx.net/login/oauth/authorize?client_id=32f589e2381c38fbd5b7&response_type=code&redirect_uri=https://pokev9.52kx.net/callback&scope=read&state=casdoor
    window.location.href = `https://cas.52kx.net/login/oauth/authorize?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code&scope=read&state=casdoor`;

  }

  return (
    <div>
      <div>
        <button
          className="firebaseui-idp-button"
          style={{ display: "flex", alignItems: "center" , backgroundColor: "#41ad4a", border: "1px solid #ddd"}}
          onClick={signIn}
          disabled={!enabled}
        >
          <img style={{ width: "30px" }} src="assets/ui/adjacent.svg" />
          <span
            style={{ color: "#47525c", paddingLeft: "5px"  , minWidth: "250px"}}
            className="firebaseui-idp-text"
          >
            {"通过 CAS 登录(推荐)"}
          </span>
        </button>
      </div>
    </div>
  )
}
